import classNames from 'classnames'

import { ICON_HEIGHT_20, IconNG } from '../../Icon'
import { Skeleton } from '../../Skeleton'
import { WidgetPipelineActions } from '../WidgetPipelineActions'

import * as styles from './WidgetItemPipelineBase.module.css'

import ErrorIcon from '../../../icons/unique/error-color.svg'
import SuccessIcon from '../../../icons/unique/success.svg'

function WidgetItemPipelineBase({
  Actions = WidgetPipelineActions,
  actionsProps,
  activeWidget,
  children,
  className = styles.WidgetItemPipelineBase,
  contentClassName = styles.WidgetItemPipelineBaseContent,
  done,
  hasError,
  headerClassName = styles.WidgetItemPipelineBaseHeader,
  index,
  isSkeleton,
  itemsLength,
  name,
  title,
  unvisited,
  onClickPrevious,
}) {
  const active = activeWidget === name

  return (
    <div
      className={classNames(className, {
        [styles.unvisited]: unvisited,
      })}
    >
      <div className={headerClassName}>
        {isSkeleton ? (
          <Skeleton
            className={classNames(styles.skeleton, styles.headerSkeleton)}
          />
        ) : (
          <>
            <span className={styles.index}>{index + 1}</span>
            <span className={styles.title}>{title}</span>
            {done || hasError ? (
              <IconNG
                Icon={hasError ? ErrorIcon : SuccessIcon}
                className={styles.headerIcon}
                size={ICON_HEIGHT_20}
              />
            ) : null}
          </>
        )}
      </div>

      <div
        className={classNames(contentClassName, {
          [styles.hidden]: !active,
        })}
      >
        {isSkeleton ? (
          <Skeleton
            className={classNames(styles.skeleton, styles.contentSkeleton)}
          />
        ) : (
          children
        )}
      </div>

      {Actions && active && !isSkeleton ? (
        <Actions
          {...actionsProps}
          index={index}
          itemsLength={itemsLength}
          onClickPrevious={onClickPrevious}
        />
      ) : null}
    </div>
  )
}

export default WidgetItemPipelineBase
